import { KeycloakComponent } from './components/keycloak/keycloak.component';
import { Routes } from '@angular/router';
import { NafathLoginComponent } from './components/nafath-login/nafath-login.component';

export const routes: Routes = [
  {
    path: ':lang/auth',
    component: KeycloakComponent,
    data: { hasHeader: false, hasFooter: false }
  }
];